import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronCircleLeft, faChevronCircleRight} from '@fortawesome/free-solid-svg-icons';
import { LabelText } from '../../../components/Language';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { parse } from 'date-fns';
import './PrevNextDate.css';

function PrevNextDate(props) {

  const [isMinDate , setIsMinDate] = useState(false);
  const [isMaxDate , setIsMaxDate] = useState(false);

  const nextDayTooltip = (
        <Tooltip id="NextDayButton">
          <LabelText tid={props.isMonthlyIntakeCalender ? "next_month"
              : props.isWeekly ? "next_week" : "next_day"} />
        </Tooltip>
  )

  const prevDayTooltip = (
        <Tooltip id="PrevDayButton">
          <LabelText tid={props.isMonthlyIntakeCalender ? "prev_month"
              : props.isWeekly ? "previous_week" : "prev_day"} />
        </Tooltip>
  ) 

    
  const getPrevDate = () => {
      setIsMaxDate(false);
      var minDate = parse(props.minDate, "dd/MM/yyyy", new Date());
      var date = new Date(props.revenueDate);
      var newDate = new Date(date);
      props.isMonthlyIntakeCalender ?  newDate.setMonth(newDate.getMonth()-1):newDate.setDate(newDate.getDate() - 1)
      if(newDate.getTime() < minDate.getTime())
      {
        setIsMinDate(true);
      } 
      else
      {
        props.dateChangeHandler(newDate);
        setMinMaxDate(newDate , "min"); 
      }
  }

  const getNextDate = () => {
    setIsMinDate(false);
    var maxDate = parse(props.maxDate, "dd/MM/yyyy", new Date());
    var date = new Date(props.revenueDate);
    var newDate = new Date(date);
      props.isMonthlyIntakeCalender ? newDate.setMonth(newDate.getMonth() + 1)
          : props.isWeekly ? (maxDate.getDate() - newDate.getDate() < 7) 
          ? newDate.setDate((newDate.getDate()) + (1 + (maxDate.getDate() - newDate.getDate())))  
          : newDate.setDate(newDate.getDate() + 7)
          : newDate.setDate(newDate.getDate() + 1)     
		  
    if(newDate.getTime() > maxDate.getTime())
    {
      setIsMaxDate(true);
    }
    else
    {
      props.dateChangeHandler(newDate);
      setMinMaxDate(newDate, "max");  
    }
  }

  const setMinMaxDate = (changedDate, dateType) => {
    if(dateType === "max")
    {
      var maxDateValue = parse(props.maxDate, "dd/MM/yyyy", new Date()); 
      changedDate.getTime() === maxDateValue.getTime() ? setIsMaxDate(true) : setIsMaxDate(false);
    }
   else if(dateType === "min")
    { 
      var minDateValue = parse(props.minDate, "dd/MM/yyyy", new Date());
      changedDate.getTime() === minDateValue.getTime() ? setIsMinDate(true) : setIsMinDate(false);
    } 
    else
    {
      var minValue = parse(props.minDate, "dd/MM/yyyy", new Date());
      var maxValue = parse(props.maxDate, "dd/MM/yyyy", new Date()); 
      changedDate.getTime() === maxValue.getTime() ? setIsMaxDate(true) : setIsMaxDate(false);
      changedDate.getTime() === minValue.getTime() ? setIsMinDate(true) : setIsMinDate(false);
    }
  }

  useEffect(() => {
    setMinMaxDate(props.revenueDate, "");
  }, [props.revenueDate]);
 
  return (
        <>
            <OverlayTrigger placement="top" overlay={prevDayTooltip}>               
                <div className="arrow-container" >
                     <FontAwesomeIcon  className = {isMinDate ? "Disabled" :
                      "Not-Disabled"} icon = {faChevronCircleLeft} role="button" onClick={() => getPrevDate()}
                       onKeyDown={(e) => { if (e.key === "Enter")  getPrevDate() }} tabIndex="0" />
                </div>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={nextDayTooltip}>               
                <div className="arrow-container" >
                    <FontAwesomeIcon className = {isMaxDate ? "Disabled" :
                     "Not-Disabled"}
                     icon = {faChevronCircleRight} role="button" onClick={() => getNextDate()} 
                      onKeyDown={(e) => { if (e.key === "Enter") getNextDate() }} tabIndex="0" />
                </div>
            </OverlayTrigger>
        </>
  ) 
}

export default PrevNextDate;